module.exports = __webpack_public_path__ + "cd9603dd44bee931b9d9d21ac859dde4.png";